/*jshint esversion: 9 */
import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { observer } from "mobx-react";
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';

// add dialog
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { sha3_512 } from 'js-sha3';

import store from '../../../components/stores/Store';
import { getAllUsers, getAllRoles, addUser }
  from '../../../db/SystemOperationRequestHandler';
import { getIfFuncAuthorized } from '../../../utils/CheckSomething';
import CheckHandler from '../../../utils/CheckHandler';
import ITextField from '../../../components/UI/ITextField';

const styles = {
  root: {},
  textField: {
    width: '15ch',
  },
  formControl: {
    margin: '10px',
    minWidth: '20ch',
  },
  rootform: {
    textAlign: 'left',
  },
  button: {
    marginLeft: '10px',
    marginTop: '10px',
  }
};
// NavigateLeft
class SelectionOfUserManagementInner extends Component {
  constructor() {
    super();
    this.state = {
      addDialogOpen: false,
      addDialogParams: {
        roleName: '',
        phone: '',
        password: '',
        roleTypeID: '',
        remark: '',
      },
    };
    this.handleChange = this.handleChange.bind(this);
    this.addNew = this.addNew.bind(this);
    this.search = this.search.bind(this);
    this.onAddDialogParamChange = this.onAddDialogParamChange.bind(this);
    this.getAllRoleTypes = this.getAllRoleTypes.bind(this);
    this.openAddDialog = this.openAddDialog.bind(this);
  }

  async componentDidMount() {
    store.search = this.search;
    this.search();
    this.getAllRoleTypes();
  }
  componentWillUnmount() { }

  handleChange(event) {
    this.setState({ age: event.target.value });
  }

  async getAllRoleTypes() {
    const rst = await getAllRoles({});
    if (rst.code === 'error') {
      store.openMessageDialogOpen(rst.msg || '查询错误');
      return true;
    } else if (rst.code === 'success') {
      console.log(`----- getAllRoleTypes rst: `, rst);
      store.setRoleTable(rst.data);
      return true;
    }
  }

  onAddDialogParamChange(e, prop) {
    e.stopPropagation();
    const newAddDialogParams = this.state.addDialogParams;
    const text = e.target.value;
    newAddDialogParams[prop] = text;

    this.setState({ addDialogParams: newAddDialogParams });
  }

  async addNew() {
    const roleName = this.state.addDialogParams.roleName.trim();
    const phone = this.state.addDialogParams.phone.trim();
    let password = this.state.addDialogParams.password;
    const roleTypeID = this.state.addDialogParams.roleTypeID;
    const remark = (this.state.addDialogParams.remark || '').trim();

    const chkRst = CheckHandler.checkParams([
      { key: '手机号码', value: phone, notNull: true, type: 'phone', maxLength: 11 },
      { key: '用户密码', value: password, notNull: true, type: 'weakPwd', maxLength: 20 },
      { key: '用户姓名', value: roleName, notNull: true, type: '', maxLength: 20 },
      { key: '用户类型', value: roleTypeID, notNull: true, type: '', maxLength: 64 },
      { key: '备注', value: remark, notNull: false, type: '', maxLength: 20 },
    ]);

    if (chkRst.msg) {
      store.openMessageDialogOpen(chkRst.msg);
      return;
    }

    // 密码加密
    if(password) password = sha3_512(password);

    console.log(`----- send req of  addUser: `, {
      roleName, phone, password, roleTypeID, remark
    });
    const rst = await addUser({
      phone, password, roleName, roleTypeID, remark
    });
    console.log(`----- rst of addUser: `, rst);
    if (rst.code === 'error') {
      store.openMessageDialogOpen(rst.msg || '系统错误');
      return true;
    } else if (rst.code === 'success') {
      console.log(`----- rst: `, rst);
      store.openMessageDialogOpen(rst.msg || '新增成功');
      this.setState({ addDialogOpen: false });
      this.search();
      return true;
    }
  }

  async search() {
    if (!getIfFuncAuthorized('系统管理-用户管理-查找')) {
      store.openMessageDialogOpen('权限不足');
      return;
    }
    const rst = await getAllUsers();
    if (rst.code === 'error') {
      store.openMessageDialogOpen(rst.msg || '查询错误');
      return true;
    } else if (rst.code === 'success') {
      console.log(`----- search rst: `, rst);
      store.setTable(rst.data);
      return true;
    }
  }

  openAddDialog() {
    this.setState({
      addDialogOpen: true,
      addDialogParams: {
        roleName: '',
        phone: '',
        password: '',
        roleTypeID: '',
        remark: '',
      },
    });
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <form className={classes.rootform} noValidate autoComplete="off">
          {(getIfFuncAuthorized('系统管理-用户管理-添加')) && (
            <Button color="primary" variant="contained"
              aria-label="contained primary button group"
              className={classes.button}
              onClick={e => this.openAddDialog()}
            >
              新增用户
            </Button>
          )}

          <Button color="primary" variant="contained"
            aria-label="contained primary button group"
            className={classes.button}
            onClick={this.search}
          >
            刷新
          </Button>
        </form>

        <Dialog aria-labelledby="form-dialog-title"
          open={this.state.addDialogOpen}
          onClose={e => this.setState({ addDialogOpen: false })}>
          <DialogTitle id="form-dialog-title" style={{ width: '300px' }}>
            新增用户
          </DialogTitle>
          <DialogContent>
            <ITextField
              autoFocus
              margin="dense"
              id="name"
              label="手机号码"
              fullWidth

              ivalue={this.state.addDialogParams.phone}
              onChange={e => this.onAddDialogParamChange(e, 'phone')}
              type="phone"
              maxLength='11'
              notNull
            />
            <ITextField
              margin="dense"
              id="name"
              label="用户密码"
              fullWidth

              ivalue={this.state.addDialogParams.password}
              onChange={e => this.onAddDialogParamChange(e, 'password')}
              type="weakPwd"
              maxLength='20'
              notNull
            />
            <ITextField
              margin="dense"
              id="name"
              label="用户姓名"
              fullWidth

              ivalue={this.state.addDialogParams.roleName}
              onChange={e => this.onAddDialogParamChange(e, 'roleName')}
              type=""
              maxLength='16'
              notNull
            />
            <FormControl fullWidth style={{ marginTop: '18px' }}>
              <InputLabel id="demo-simple-select-outlined-label" style={{ marginTop: '-8px' }}>
                用户类型
              </InputLabel>
              <Select
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                value={this.state.addDialogParams.roleTypeID}
                onChange={e => this.onAddDialogParamChange(e, 'roleTypeID')}
                fullWidth
                label="用户类型"
                margin="dense"
              >
                <MenuItem value="">
                  <em>请选择</em>
                </MenuItem>
                {store.roleTable.map((row, index) => {
                  const ID = row.ID;
                  const roleName = row.rolename;
                  return (<MenuItem value={ID} key={ID}>{roleName}</MenuItem>);
                })}
              </Select>
            </FormControl>

            <ITextField
              autoFocus
              margin="dense"
              id="name"
              label="备注信息"
              fullWidth

              ivalue={this.state.addDialogParams.remark}
              onChange={e => this.onAddDialogParamChange(e, 'remark')}
              type=""
              maxLength='20'
              notNull={false}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.addNew} color="primary" variant="contained"
              aria-label="contained primary button group">
              确认添加
            </Button>
            <Button onClick={e => this.setState({ addDialogOpen: false })}
              color="primary" variant="contained"
              aria-label="contained primary button group">
              取消
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

const SelectionOfUserManagement = observer(SelectionOfUserManagementInner);

SelectionOfUserManagement.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SelectionOfUserManagement);
